import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { AckRequestService } from 'src/app/services/ack-request.service';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { AuthService } from 'src/app/services/auth.service';
import { ChatService } from 'src/app/services/chat.service';
import { RequestApiService } from 'src/app/services/domain_code/request-api.service';
import { ReleaseOrderService } from 'src/app/services/release-order.service';
import { ReturnContainersService } from 'src/app/services/return-containers.service';

@Component({
  selector: 'logzy-ops-date-change-view',
  templateUrl: './ops-date-change-view.component.html',
  styleUrls: ['./ops-date-change-view.component.scss']
})
export class OpsDateChangeViewComponent implements OnInit {
  request_url = `${ApiRoutes.LeadRequest}request_details/`;
  request: string;

  constructor(public requestService: RequestApiService,
    private route: ActivatedRoute,
    private ackRequest: AckRequestService,
    private router: Router,
    private dialog: MatDialog,
    public authService: AuthService,
    public releaseservice: ReleaseOrderService,
    public chatService: ChatService,
    private _liveAnnouncer: LiveAnnouncer,
    private returnContainerService: ReturnContainersService,
    private snackBar: MatSnackBar) { }

  ngOnInit(): void {
  }
  back() {
    this.router.navigateByUrl(`ops-date-change/list`);
  }
  onRequestSelection(event) {
    if (event != null) {
      this.chatService.noAccessToChat = false;
      this.router.navigateByUrl(`/ops-date-change/request-details?id=${event.id}&type=${event.transaction_type}&rtype=${event.request_type.dev_name}`);
    }
  }
}
